"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xp(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.0925 17.25H9.744L8.9325 14.0625L10.9163 13.026L11.562 14.871L12.0428 12.4373L14.679 11.0595L14.5335 11.7915L16.056 11.8057C16.644 11.7968 17.0993 11.598 17.4233 11.211C17.7473 10.8232 17.901 10.3035 17.8845 9.64875C17.8819 9.56447 17.8731 9.4805 17.8583 9.3975L19.9058 8.32725C20.1893 8.8485 20.2973 9.46275 20.2313 10.1685C20.1218 11.1975 19.6763 12.021 18.897 12.6382C18.1178 13.2562 17.124 13.5652 15.9173 13.5652L14.1878 13.5577L13.455 17.25H11.0925ZM11.4083 9.0075H12.7208L10.698 11.8763L5.703 14.487L7.554 11.8695L5.775 6.75H8.385L9.3075 10.3417L10.0965 9.00675H11.409H10.0965L11.505 6.75H13.1663L17.0108 6.7575C17.8845 6.7815 18.6008 7.01325 19.1603 7.45275L17.0603 8.55075C17.0087 8.54118 16.9566 8.53467 16.9043 8.53125L15.1838 8.51625L14.9588 9.64875L12.321 11.0273L12.72 9.00675L11.4083 9.0075ZM4.3395 16.464L8.33475 14.3752L6.57375 17.25H3.75L4.32525 16.4363L4.3395 16.464Z", fill: color }));
}
exports["default"] = xp;
//# sourceMappingURL=xp.js.map